import isBlank from "@sedan-utils/is-blank";
import { FuncResponse, FuncResponseType, FunctionBase } from "../../storyV2/function/FunctionBase";
import { FunctionUtil } from "../../storyV2/function/FunctionUtil";
class LocationAndKeyword {
    constructor() {
        this.keyword = "";
        this.location = "";
    }
}
export class MapFunction extends FunctionBase {
    constructor(brainClient, authStore, locationManager) {
        super(brainClient, authStore);
        this.brainClient = brainClient;
        this.authStore = authStore;
        this.locationManager = locationManager;
    }
    async run(input, identityInfo) {
        const locationAndKeyword = this.getLoactionAndKeywordData(input);
        let location = [];
        if (locationAndKeyword.location === "NONE") {
            const res = await this.locationManager.getLocation(false);
            if (res === undefined) {
                locationAndKeyword.location = "";
            }
            else {
                location = [res.lng, res.lat];
            }
        }
        else if (!isBlank(locationAndKeyword.location)) {
            const address = await this.getAddressInfo(locationAndKeyword.location, FunctionUtil.createAbortUuid(identityInfo));
            const res = address?.results.first()?.geometry?.location ?? { lng: 0, lat: 0 };
            location = [res.lng, res.lat];
        }
        let res = await this.getAddressPoints(locationAndKeyword.keyword, location, FunctionUtil.createAbortUuid(identityInfo));
        // const res = await this.brainClient.map.getMapTextSearch(params.keyword, locationLatLng);
        //
        // if (isEmpty(res.results)) {
        //   throw `"${params.keyword}" did not return data.`
        // }
        // res?.results?.forEach((x: ResultGoogleType) => {
        //   x.keyword = params.keyword
        // })
        // if (this.isMultInput.value) {
        //   this.mapList.value = this.mapList.value.concat([]);
        //   const obj = get(res, "results.[0]", {});
        //   this.mapList.value = [...this.mapList.value, obj];
        // } else {
        //   const arr = get(res, "results", []);
        //   this.mapList.value = arr.slice(0, 15);
        // }
        return new FuncResponse(FuncResponseType.MAP, res?.results ?? []);
    }
    async getAddressInfo(query, uuid) {
        const result = await this.brainClient.openAi.getAddress(query, uuid);
        return result?.data?.data;
    }
    async getAddressPoints(keyword, location, uuid) {
        const result = await this.brainClient.openAi.getMapTextSearch(keyword, location, uuid);
        return result?.data?.data;
    }
    getLoactionAndKeywordData(text) {
        const arr = text.split("\n").filter((x) => x);
        const obj = new LocationAndKeyword();
        arr.forEach(x => {
            const resultArr = x.split(":").filter((j) => j.trim());
            if (isBlank(resultArr))
                return;
            if (resultArr[0] === "keyword") {
                obj.keyword = resultArr?.[1]?.trim() || "";
            }
            if (resultArr[0] === "location") {
                obj.location = resultArr?.[1]?.trim() || "";
            }
        });
        return obj;
    }
}
